import {Injectable} from '@angular/core';
import {Logger} from '../utils/Logger';
import {ConfigService} from '../service/config.service';
import {ChannelPartnerService} from '../service/channel-partner.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';

@Injectable()
export class OnlyPartnersOfferingEligibilityCheckGuard implements CanActivate {
    private router: Router;
    private configService: ConfigService;
    private channelPartnerService: ChannelPartnerService;

    constructor(router: Router, channelPartnerService: ChannelPartnerService, configService: ConfigService) {
        this.router = router;
        this.configService = configService;
        this.channelPartnerService = channelPartnerService;
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const channelPartnerId = route.queryParams['channel-partner-id'];
        const eligibilityCheckOfferedByPartnerGroupId = this.configService.getPartnerGroupIdOfferingEligibilityCheck();
        const channelPartner = await this.channelPartnerService.getPartnerDetails(channelPartnerId);
        if (channelPartner.partnerGroupIds.includes(eligibilityCheckOfferedByPartnerGroupId)) {
             return true;
        } else {
            Logger.log(`${channelPartnerId} not eligible for check. Navigating to borrower home page.`);
            return this.router.createUrlTree(['/borrow']);
        }
    }
}
